export default "__VITE_ASSET__ICL_Kucx__"